export default __webpack_public_path__ + "static/funnel-steps-breakdown-light-mode-913ef0ee64b675ba3bf3fbab0dcb8e74.png";